<template>
  <div>
    <div class="tile is-parent pl-1">
      <div class="tile is-child box">

        <div class="tabs">
          <ul>
            <li :class="{ 'is-active' : subComponent === 'OrmQdeVersionChange' }">
              <a @click="subComponent = 'OrmQdeVersionChange'">QDE Version Change</a>
            </li>
          </ul>
        </div>
        <div v-if="subComponent === 'OrmQdeVersionChange'">
          <div class="subtitle">Send QDE Version Change to ORM</div>

          <div class="columns">
            <div class="column is-one-quarter">
              <div class="columns has-text-weight-bold">
                <div class="column is-half">QDE Version</div>
                <div class="column">
                  <div class="select is-fullwidth"
                    style="width: 100px">
                    <select v-model="ormQdeVersion">
                      <option value="null"
                        disabled>Select</option>
                      <option v-for="(a, b) in ormQdeVersionTypes"
                        :value="a"
                        :key="b">{{ a }}</option>
                    </select>
                  </div>
                </div>
              </div>

              <div class="columns">
                <div class="column is-half has-text-weight-bold">Repairer ID</div>
                <div class="column">
                  <input type="text"
                    class="input"
                    :class="{ 'is-danger': $v.repairerId.$error }"
                    style="max-width: 12em"
                    placeholder="Repairer ID"
                    v-model="repairerId">
                  <span v-if="$v.repairerId.$error"
                    class="help is-danger">Please enter a valid Repairer ID</span>
                </div>
              </div>
            </div>
          </div>

          <button class="button is-primary"
            @click="sendQdeVersionChange">Send</button>

        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { required } from 'vuelidate/lib/validators'
import { OrmQdeVersionTypes } from '@/enums'
import { OrmService } from '@/services'

export default {
  name: 'CompanyOrmUtilities',
  components: {},
  validations: {
    repairerId: {
      required
    }
  },
  mixins: [],
  props: {
    value: null
  },
  data: () => {
    return {
      companySetting: null,
      subComponent: 'OrmQdeVersionChange',
      repairerId: '',
      ormQdeVersion: null
    }
  },
  computed: {
    ormQdeVersionTypes: function () {
      return OrmQdeVersionTypes
    }
  },
  watch: {},
  async created() {
    await this.getOrmQdeSetting()
  },
  mounted() {
  },
  beforeDestroy() {},
  methods: {
    ...mapActions('company', ['getCompanySetting']),
    async sendQdeVersionChange() {
      this.$v.repairerId.$touch()
      if (this.$v.repairerId.$error) {
        return
      }
      try {
        const _ormQdeVersion = Object.keys(this.ormQdeVersionTypes).find(key => this.ormQdeVersionTypes[key] === this.ormQdeVersion)
        await OrmService.sendQdeVersionChange(this.repairerId, _ormQdeVersion)
        this.$toast.open({
          message: 'QDE Version Change sent successfully.',
          type: 'is-success',
          duration: 5000
        })
      } catch (e) {
        this.isActive = false
        this.$emit('update:active', false)
        this.$toast.open({
          message: `${e.message}`,
          type: 'is-danger',
          duration: 5000
        })
      }
      //
      // console.log(result)
    },
    async getOrmQdeSetting() {
      const ormQdeVersion = await OrmService.getOrmQdeVersion()
      this.ormQdeVersion = ormQdeVersion
    }
  },
  beforeRouteEnter(to, from, next) {
    next()
  },
  beforeRouteLeave(to, from, next) {
    next()
  }
}
</script>

<style lang="scss" scoped>
.list-style-reset {
  margin-top: 1em;
  li {
    list-style: initial;
    list-style-type: disc;
    margin-left: 2em;
  }
}
</style>